import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-family: 'Segoe UI', sans-serif;
    margin: 0;
    padding: 0;
  }

  body {
    background-color: #f0f2f5;
    padding: 20px;
  }
`

export default GlobalStyles
